import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import firestore from "./firebase.config";
import { useAuth } from "./context/AuthContext";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import {
    ThemeProvider,
    createMuiTheme,
    fade,
    makeStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MailIcon from "@material-ui/icons/Mail";
import NotificationsIcon from "@material-ui/icons/Notifications";
import MoreIcon from "@material-ui/icons/MoreVert";
import {
    AppBar,
    Badge,
    Toolbar,
    Typography,
    MenuItem,
    Menu,
    IconButton,
    InputBase,
    TextField,
    Fab,
    Zoom,
    useScrollTrigger,
} from "@material-ui/core/";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Autocomplete } from "@material-ui/lab";
import About from "./pages/About";
import Video from "./pages/Video";
import Browse from "./pages/Browse";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import UpdateProfile from "./pages/UpdateProfile";
import logo from "./logo.png";
import PrivateRoute from "./pages/Authentication/PrivateRoute";
import Auth from "./pages/Authentication/Login";
import Signup from "./pages/Authentication/Signup";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import SearchCategory from "./pages/SearchCategory";

import "./App.css";

const theme = createMuiTheme({
    typography: {
        fontFamily: ["Tomorrow", "sans-serif"].join(","),
    },
    palette: {
        primary: {
            light: "#4fb3bf",
            main: "#00838f",
            dark: "#005662",
            contrastText: "#ffffff",
        },
        secondary: {
            light: "#ffffb3",
            main: "#f4ff81",
            dark: "#bfcc50",
            contrastText: "#000",
        },
    },
});

function ScrollTop(props) {
    const { children, window } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector(
            "#back-to-top-anchor"
        );

        if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    return (
        <Zoom in={trigger}>
            <div
                onClick={handleClick}
                role="presentation"
                className={classes.root}
            >
                {children}
            </div>
        </Zoom>
    );
}

function App() {
    const [videos, setVideos] = useState([]);
    const history = useHistory();
    const classes = useStyles();
    const { currentUser, logout } = useAuth();
    const [userinfo, setUserInfo] = useState();

    const fetchVideos = async () => {
        const data = await firestore.collection("videos").get();
        setVideos(data.docs.map((doc) => doc.data()));
    };

    const getUserDetail = async (uID) => {
        const userRef = await firestore.collection("users").doc(uID).get();
        const data = userRef.data();
        setUserInfo(data);
    };

    async function handleLogout() {
        try {
            await logout();
            history.push("/login");
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchVideos();
        if (currentUser) {
            getUserDetail(currentUser.uid);
        }

        console.log(userinfo);
    }, [currentUser]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const menuId = "primary-search-account-menu";
    const renderMenu = (
        <Menu
            className={classes.menuButton}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>
                <Link
                    to="/account"
                    style={{
                        textDecoration: "none",
                        color: theme.palette.primary.main,
                    }}
                    className={classes.menuButton}
                >
                    Profile
                </Link>
            </MenuItem>
            <MenuItem onClick={(handleMenuClose, handleLogout)}>
                <Link
                    style={{
                        textDecoration: "none",
                        color: theme.palette.primary.main,
                    }}
                >
                    Logout
                </Link>
            </MenuItem>
        </Menu>
    );

    const mobileMenuId = "primary-search-account-menu-mobile";
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
            className={classes.menuButton}
        >
            {userinfo ? (
                <>
                    <MenuItem>
                        <IconButton aria-label="show new mails" color="inherit">
                            <Badge badgeContent={1} color="secondary">
                                <MailIcon />
                            </Badge>
                        </IconButton>
                        <p>Messages</p>
                    </MenuItem>
                    <MenuItem>
                        <IconButton
                            aria-label="show new notifications"
                            color="inherit"
                        >
                            <Badge badgeContent={1} color="secondary">
                                <NotificationsIcon />
                            </Badge>
                        </IconButton>
                        <p>Notifications</p>
                    </MenuItem>
                    <MenuItem onClick={handleProfileMenuOpen}>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="primary-search-account-menu"
                            aria-haspopup="true"
                            color="inherit"
                        >
                            <AccountCircle />
                        </IconButton>
                        <p>Profile</p>
                    </MenuItem>
                </>
            ) : (
                <>
                    <div>
                        <Link to="/login" style={{ textDecoration: "none" }}>
                            <Typography
                                style={{
                                    margin: 20,
                                    color: "primary",
                                }}
                            >
                                Sign In
                            </Typography>
                        </Link>
                    </div>
                    <div>
                        <Link to="/signup" style={{ textDecoration: "none" }}>
                            <Typography
                                style={{
                                    margin: 20,
                                    color: "primary",
                                }}
                            >
                                Sign Up
                            </Typography>
                        </Link>
                    </div>
                </>
            )}
        </Menu>
    );

    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <Router>
                    <AppBar
                        position="static"
                        color="primary"
                        id="back-to-top-anchor"
                    >
                        <Toolbar
                            style={{ flexGrow: 1 }}
                            justify="space-between"
                        >
                            <img
                                src={logo}
                                alt="VLearnAI"
                                className={classes.logo}
                            />
                            <Link
                                to="/"
                                style={{
                                    textDecoration: "none",
                                    flexGrow: 1,
                                }}
                            >
                                <Typography
                                    style={{
                                        textAlign: "left",
                                        color: "#ffffff",
                                        fontWeight: 500,
                                        fontSize: 32,
                                    }}
                                    className={classes.title}
                                    noWrap
                                >
                                    VLearnAI
                                </Typography>
                            </Link>
                            {userinfo ? (
                                <>
                                    <Autocomplete
                                        style={{
                                            width: 300,
                                            border: "none",
                                            borderRadius: "10px",
                                            position: "relative",
                                            marginRight: theme.spacing(2),
                                            [theme.breakpoints.up("sm")]: {
                                                marginLeft: theme.spacing(3),
                                                width: "auto",
                                            },
                                        }}
                                        freeSolo
                                        options={videos}
                                        getOptionLabel={(option) =>
                                            option.title
                                        }
                                        renderOption={(option) => (
                                            <React.Fragment>
                                                {videos ? (
                                                    <Link
                                                        to={`/playVideo/${option.videoId}`}
                                                        style={{
                                                            textDecoration:
                                                                "none",
                                                        }}
                                                    >
                                                        <Typography variant="body">
                                                            {option.title}
                                                        </Typography>
                                                    </Link>
                                                ) : null}
                                            </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                label="Search"
                                                style={{
                                                    backgroundColor: "#E5E5E5",
                                                    border: "none",
                                                    borderRadius: "10px",
                                                }}
                                            />
                                        )}
                                    />
                                    <div className={classes.sectionDesktop}>
                                        {userinfo.role === "admin" && (
                                            <Link
                                                to="/admindashboard"
                                                style={{
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <Typography
                                                    style={{
                                                        margin: 20,
                                                        color: "#ffffff",
                                                    }}
                                                >
                                                    Admin
                                                </Typography>
                                            </Link>
                                        )}
                                        <Link
                                            to="/about"
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Typography
                                                style={{
                                                    margin: 20,
                                                    color: "#ffffff",
                                                }}
                                            >
                                                About
                                            </Typography>
                                        </Link>

                                        <Link
                                            to="/dashboard"
                                            style={{
                                                textDecoration: "none",
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    margin: 20,
                                                    color: "#ffffff",
                                                }}
                                            >
                                                Dashboard
                                            </Typography>
                                        </Link>

                                        <IconButton
                                            aria-label="show new mails"
                                            color="inherit"
                                        >
                                            <Badge
                                                badgeContent={1}
                                                color="secondary"
                                            >
                                                <MailIcon />
                                            </Badge>
                                        </IconButton>
                                        <IconButton
                                            aria-label="show new notifications"
                                            color="inherit"
                                        >
                                            <Badge
                                                badgeContent={1}
                                                color="secondary"
                                            >
                                                <NotificationsIcon />
                                            </Badge>
                                        </IconButton>
                                        <IconButton
                                            edge="end"
                                            aria-label="account of current user"
                                            aria-controls={menuId}
                                            aria-haspopup="true"
                                            onClick={handleProfileMenuOpen}
                                            color="inherit"
                                        >
                                            <AccountCircle />
                                        </IconButton>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={classes.sectionDesktop}>
                                        <Link
                                            to="/login"
                                            style={{ textDecoration: "none" }}
                                        >
                                            <Typography
                                                style={{
                                                    margin: 20,
                                                    color: "#ffffff",
                                                }}
                                            >
                                                Sign In
                                            </Typography>
                                        </Link>
                                    </div>
                                    <div className={classes.sectionDesktop}>
                                        <Button
                                            variant="contained"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                color: "primary",
                                            }}
                                            href="/signup"
                                        >
                                            Sign Up
                                        </Button>
                                    </div>
                                </>
                            )}
                            <div className={classes.sectionMobile}>
                                <IconButton
                                    aria-label="show more"
                                    aria-controls={mobileMenuId}
                                    aria-haspopup="true"
                                    onClick={handleMobileMenuOpen}
                                    color="inherit"
                                >
                                    <MoreIcon />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>
                    {renderMobileMenu}
                    {renderMenu}

                    <Switch>
                        <Route exact path="/" component={Browse}></Route>
                        <Route path="/about" component={About}></Route>
                        <PrivateRoute
                            path="/dashboard"
                            component={Dashboard}
                        ></PrivateRoute>
                        <PrivateRoute
                            path="/account"
                            component={Account}
                        ></PrivateRoute>
                        <PrivateRoute
                            path="/update-profile"
                            component={UpdateProfile}
                        ></PrivateRoute>
                        <PrivateRoute
                            path={"/playVideo/:videoId"}
                            exact
                            component={Video}
                        ></PrivateRoute>
                        <PrivateRoute
                            path="/admindashboard"
                            component={AdminDashboard}
                        ></PrivateRoute>
                        <Route exact path="/search-category">
                            <SearchCategory />
                        </Route>
                        <Route path="/login">
                            <Auth />
                        </Route>
                        <Route path="/signup">
                            <Signup />
                        </Route>
                        <Route path="/forgot-password">
                            <ForgotPassword />
                        </Route>
                        <Route
                            path="/manage-users"
                            component={AdminDashboard}
                        ></Route>
                        <Route
                            path="/manage-videos"
                            component={AdminDashboard}
                        ></Route>
                    </Switch>
                </Router>
            </div>
            <ScrollTop>
                <Fab
                    color="primary"
                    size="small"
                    aria-label="scroll back to top"
                >
                    <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>
        </ThemeProvider>
    );
}

export default App;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        textAlign: "left",
        display: "none",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
        color: "#FFFFFF",
    },

    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(1),
            width: "auto",
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            width: "12ch",
            "&:focus": {
                width: "20ch",
            },
        },
    },

    logo: {
        maxWidth: 40,
        marginRight: "10px",
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
        width: 200,
    },
    sectionDesktop: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "flex",
        },
    },
    sectionMobile: {
        display: "flex",
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
}));
